import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static readonly targets = ['selector', 'container'];
  static readonly classes = ['hidden'];
  static readonly values = {
    selectId: String,
  };

  declare selectIdValue: string;
  declare containerTargets: HTMLElement[];
  declare selectorTarget: HTMLElement;
  declare hiddenClasses: string[];

  onClick = (event: Event) => {
    const selectedElement = event.currentTarget as HTMLElement;
    this.toggleSelectForm(selectedElement.id);
  };

  private toggleSelectForm(selected: string) {
    for (const element of this.containerTargets) {
      if (element.id === selected) {
        element.classList.remove(this.hiddenClasses.join(' '));
      } else {
        element.classList.add(this.hiddenClasses.join(' '));
      }
    }
  }
}
